import React, { useState, useEffect } from 'react';
import { Slider } from '@/components/ui/slider';
import { splitAmount, times100, extractNumber } from '@/lib/utils';
import { type TotalData, OverviewTabKeyNames } from '../../index.type';

interface TradingFeaturesProps {
  selectedMetrics: {
    tradingFeatures?: boolean;
    [key: string]: boolean | undefined;
  };
  selectChange: (key: string, checked: boolean) => void;
  totalData: Pick<TotalData, OverviewTabKeyNames>;
}

const TradingFeatures: React.FC<TradingFeaturesProps> = ({
  selectedMetrics,
  selectChange,
  totalData
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    tradingFeatures?: boolean;
    [key: string]: boolean | undefined;
  }>({});
  const [currentTradingActivity, setCurrentTradingActivity] = useState<number[]>([0]);

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  useEffect(() => {
    console.log(extractNumber(totalData.trading_activity_rank), 'dldlddldldld');

    if (totalData.trading_activity_rank) {
      setCurrentTradingActivity([Number(extractNumber(totalData.trading_activity_rank))]);
    }
  }, [totalData]);

  const handleCheckboxChange = (checked: boolean) => {
    selectChange('tradingFeatures', checked);
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      tradingFeatures: checked
    }));
  };

  const handleSliderChange = (value: number[]) => {
    setCurrentTradingActivity(value);
  };

  return (
    <div className="border border-[#F0F0F0] rounded-lg p-3">
      <div className="flex items-center gap-2 mb-3">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.tradingFeatures || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="w-4 h-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">交易特征</span>
      </div>

      <div className="flex gap-3 mb-3">
        <div className="flex-1 text-left">
          <div className="text-sm text-[#1F1F1F] mb-2">月均交易次数：</div>
          <div className="text-xl font-semibold text-[#1F1F1F]">
            {splitAmount(totalData.monthly_avg_trades).num}
            <span className="text-sm font-normal ml-1">
              {splitAmount(totalData.monthly_avg_trades).unit}
            </span>
          </div>
        </div>
        <div className="flex-1 text-left">
          <div className="text-sm text-[#1F1F1F] mb-2">年换手率：</div>
          <div className="text-xl font-semibold text-[#1F1F1F]">
            {times100(totalData.annualized_turnover_rate || 0).toString()}
            <span className="text-sm font-normal ml-1">%</span>
          </div>
        </div>
      </div>

      {/* 交易活跃度滑动条 */}
      <div className="relative p-4 border-2 border-transparent rounded-xl bg-gradient-to-r from-white to-white bg-clip-padding border-gradient-to-r">
        <div className="flex justify-between items-center mb-3">
          <span className="text-sm font-semibold text-[#1F1F1F]">交易活跃度</span>
        </div>

        {/* 滑动条 */}
        <div className="relative mb-3">
          <Slider
            value={currentTradingActivity}
            onValueChange={handleSliderChange}
            thumbTooltip={
              <div className="bg-white rounded-md px-2 py-1 shadow-lg">
                <span className="text-xs text-[#1F1F1F] whitespace-nowrap">
                  战胜{currentTradingActivity[0]}% 的股民
                </span>
              </div>
            }
          />
          <div className="flex justify-between text-[10px] text-[#1F1F1F] mt-2">
            <span className="bg-[#E8ECFF] px-1 py-1 rounded">低频交易活跃度10%</span>
            <span className="bg-[#FFF1F0] px-1 py-1 rounded">高频交易活跃度100%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingFeatures;
